import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ConfirmDTO} from '../ConfirmDTO';
import {Level} from '../Level';

@Component({
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss', '../notification.shared.scss']
})
export class ConfirmDialogComponent implements OnInit {

  private areYouSure = new EventEmitter<boolean>();
  text: ConfirmDTO;

  constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public params) {
    this.text = params;
  }

  ngOnInit() {
    this.dialogRef.backdropClick().subscribe(() => this.cancel());
    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === 'Escape') {
        this.cancel();
      }
    });
  }

  ok() {
    this.resolve(true);
  }

  cancel() {
    this.resolve(false);
  }

  resolve(areYouSure) {
    this.areYouSure.emit(areYouSure);
    this.dialogRef.close();
  }

  getConfirmButtonClass(level: Level) {
    if (level === Level.DANGEROUS) {
      return 'times warning';
    } else if (level === Level.ADD) {
      return 'plus accent';
    } else {
      return 'check accent';
    }
  }

  public promise() {
    return new Promise<void>((resolve, reject) => this.areYouSure.subscribe(sure => sure ? resolve() : reject()));
  }
}
